import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCsTimeout = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 13,
	height: 16,
	viewBox: "0 0 13 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5 16C2.91417 16 0 13.1306 0 9.59995C0 6.06928 2.91417 3.19995 6.5 3.19995C10.0858 3.19995 13 6.06928 13 9.59995C13 13.1306 10.0858 16 6.5 16ZM6.5 4.26662C3.51542 4.26662 1.08333 6.66128 1.08333 9.59995C1.08333 12.5386 3.51542 14.9333 6.5 14.9333C9.48458 14.9333 11.9167 12.5386 11.9167 9.59995C11.9167 6.66128 9.48458 4.26662 6.5 4.26662Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.04232 5.33325H5.95898V10.1333H7.04232V5.33325Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.52375 2.13333H5.47083C5.14042 2.13333 4.875 1.872 4.875 1.54133V0.592C4.875 0.261333 5.14042 0 5.47625 0H7.52917C7.85958 0 8.125 0.261333 8.125 0.592V1.54667C8.125 1.872 7.85958 2.13333 7.52375 2.13333Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.1049 3.73334C10.964 3.73334 10.8286 3.68 10.7203 3.57867L9.63695 2.512C9.4257 2.304 9.4257 1.968 9.63695 1.76C9.8482 1.552 10.1895 1.552 10.4007 1.76L11.484 2.82667C11.6953 3.03467 11.6953 3.37067 11.484 3.57867C11.3811 3.68 11.2457 3.73334 11.1049 3.73334Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.62505 3.73334C1.48422 3.73334 1.3488 3.68 1.24047 3.57867C1.02922 3.37067 1.02922 3.03467 1.24047 2.82667L2.3238 1.76C2.53505 1.552 2.8763 1.552 3.08755 1.76C3.2988 1.968 3.2988 2.304 3.08755 2.512L2.00422 3.57867C1.9013 3.68 1.76589 3.73334 1.62505 3.73334Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.04232 2.1333H5.95898V3.7333H7.04232V2.1333Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.49935 10.6668C7.09766 10.6668 7.58268 10.1892 7.58268 9.60011C7.58268 9.01101 7.09766 8.53345 6.49935 8.53345C5.90104 8.53345 5.41602 9.01101 5.41602 9.60011C5.41602 10.1892 5.90104 10.6668 6.49935 10.6668Z",
			fill: "currentColor"
		})
	]
});
export default SvgCsTimeout;
